import { render, staticRenderFns } from "./AttachmentSettings.vue?vue&type=template&id=446fd6d6&"
import script from "./AttachmentSettings.vue?vue&type=script&lang=js&"
export * from "./AttachmentSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports